export const GRAVITY_CONFIG = {
    api_root: `/gravity/spring`
};